
import { defineComponent } from 'vue';
import { AppFormRow, AppInput, AppCard, AppButton, AppSelect } from '@/components';
import { useArenaTicketAdd } from '@/modules/arena/ticket/model/add';
import { ArenaTicketTypeList } from '@/modules/arena/ticket/model/mixins';
import { ROUTE_NAME_ARENA } from '@/modules/arena/router';

export default defineComponent({
    name: ROUTE_NAME_ARENA.TICKET.ADD,
    components: { AppFormRow, AppInput, AppCard, AppButton, AppSelect },
    setup() {
        const { model, v$, create } = useArenaTicketAdd();

        return { v$, model, create, ArenaTicketTypeList };
    }
});
